import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import api from './api';
import { AppThunk } from './app';
import API_URL from '../config/ApiUrl';

interface ReportsState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as ReportsState;

const ReportsSlice = createSlice({
  name: 'Reports',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = ReportsSlice.actions;

export const fetchAddReports =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.REPORTS.ADD, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
        const type = payload.type ? payload.type: "";
        const report_year = payload.report_year ? payload.report_year:  "";
        const report_date = payload.report_date ? payload.report_date : "";
        const current = payload.current ? payload.current : 1;
        const page_size = payload.page_size ? payload.page_size : 10;
        const provider_code = payload.provider_code ? payload.provider_code : "";

        const action = `?type=${type}&report_year=${report_year}&report_date=${report_date}&current=${current}&page_size=${page_size}&provider_code=${provider_code}`

      const response = await api.get(API_URL.REPORTS.LIST + action);
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchDeleteReports =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    //console.log("payload",payload);
    
    try {
      const response = await api.post(API_URL.REPORTS.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };


export default ReportsSlice.reducer;
